import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { TrackerService } from '../../../../../services/tracker.service';

@Component({
  selector: 'tracker-admin-workflow-transition-tab-action',
  template: require('./tracker.workflow.transition.tab.action.component.html'),
})
export class TrackerAdminWorkflowTransitionTabActionComponent implements OnInit {
  @Input() toFieldElement: any;
  @Input() tracker: any;
  @Input() roles: any;
  @Input() selectFields: any;

  lockStatusElements: any[] = [];
  rolesToBeNotifiedLabel: string = '';
  rolesToReassignToLabel: string = '';
  transitionChangeFieldLabel: string = '';
  transitionChangeElementLabel: string = '';
  transitionChangeLockStatusLabel: string = '';
  transitionTriggerElements: any[] = [];

  constructor(
    private trackerService: TrackerService
  ) {}

  ngOnInit() {
    this.lockStatusElements = _.union(
      [{ id: 100, value: 100, label: 'None' }],
      this.trackerService.fields.builtIn.lock_status.getList()
    );
    this.setRolesToBeNotifiedLabel();
    this.setTransitionChangeLockStatusLabel();
    this.setTransitionChangeFieldLabel();
    this.setTransitionChangeElementLabel();
    this.setRolesToReassignToLabel();
  }

  setRoleToBeNotified(role: any) {
    const notifiedRole = _.find(this.toFieldElement.notify.roles, { ref_id: role.id });

    if (notifiedRole) {
      _.remove(this.toFieldElement.notify.roles, { ref_id: role.id });
    } else {
      if (role.id === 0) this.toFieldElement.notify.roles = [];
      this.toFieldElement.notify.roles.push({ ref_id: role.id, roleName: role.roleName });
    }

    this.trackerService.fields.removeNone(this.toFieldElement.notify.roles, true);
    this.setRolesToBeNotifiedLabel();
  }

  isRoleSetToBeNotified(role: any): boolean {
    if (_.isEmpty(role)) {
      return false;
    }

    const notifiedRole = _.find(this.toFieldElement.notify.roles, (notifiedRole: any) => {
      if (notifiedRole.ref_id === role.id) {
        notifiedRole.roleName = role.roleName;
        this.setRolesToBeNotifiedLabel();
        return true;
      }
      return false;
    });

    return !!notifiedRole;
  }

  setRoleToReassignTo(role: any) {
    const reassignToRole = _.find(this.toFieldElement.reassignToRoles, { id: role.id });

    if (reassignToRole) {
      _.remove(this.toFieldElement.reassignToRoles, { id: role.id });
    } else {
      if (role.ref_id === 0) this.toFieldElement.reassignToRoles = [];
      this.toFieldElement.reassignToRoles.push({ id: role.id, roleName: role.roleName });
    }

    this.trackerService.fields.removeNone(this.toFieldElement.reassignToRoles, true);
    this.setRolesToReassignToLabel();
  }

  isRoleSetToReassignTo(role: any): boolean {
    if (_.isEmpty(role)) {
      return false;
    }

    return !!_.find(this.toFieldElement.reassignToRoles, { id: role.id });
  }

  setTransitionChangeField(field: any) {
    this.toFieldElement.changeExtraField = {
      id: field.id,
      fieldName: field.fieldName,
      alias: field.alias,
      toElementId: null,
      toElementName: 'None',
    };

    this.setTransitionTriggerElements(field.alias);
    this.setTransitionChangeFieldLabel();
    this.setTransitionChangeElementLabel();
    this.setTransitionChangeLockStatusLabel();
  }

  setTransitionChangeElement(element: any) {
    element.elementName = element.label;
    _.set(this.toFieldElement , 'changeExtraField.toElementId', element.id);
    _.set(this.toFieldElement, 'changeExtraField.toElementName', element.label);

    this.setTransitionChangeElementLabel();
    this.setTransitionChangeLockStatusLabel();
  }

  setTransitionLockStatus(element: any) {
    _.set(this.toFieldElement, 'toLockStatus', element.id);
    this.setTransitionChangeLockStatusLabel();
  }

  private setRolesToBeNotifiedLabel() {
    this.rolesToBeNotifiedLabel = _.map(this.toFieldElement.notify.roles, 'roleName').join(', ');
    if (this.rolesToBeNotifiedLabel === '') this.rolesToBeNotifiedLabel = 'None';
  }

  private setRolesToReassignToLabel() {
    this.rolesToReassignToLabel = _.map(this.toFieldElement.reassignToRoles, 'roleName').join(', ');
    if (this.rolesToReassignToLabel === '') this.rolesToReassignToLabel = 'None';
  }

  private setTransitionTriggerElements(tef_alias: string) {
    const tef = _.get(this.tracker.fields, tef_alias, {});
    if (!_.isEmpty(tef) && Array.isArray(tef.fieldElements)) {
      this.transitionTriggerElements = _.cloneDeep(tef.fieldElements);
    }
  }

  private setTransitionChangeElementLabel() {
    this.transitionChangeElementLabel = this.toFieldElement.changeExtraField?.toElementName || 'None';
  }

  private setTransitionChangeFieldLabel() {
    this.transitionChangeFieldLabel = this.toFieldElement.changeExtraField?.fieldName || 'None';
    this.setTransitionTriggerElements(this.toFieldElement.changeExtraField.alias);
  }

  private setTransitionChangeLockStatusLabel() {
    const toLockStatus = _.get(this.toFieldElement, 'toLockStatus', 100) ?? 100;
    const lockStatus = this.lockStatusElements.find((item) => item.id == toLockStatus || item.value == toLockStatus);
    this.transitionChangeLockStatusLabel = lockStatus?.label || 'None';
  }
}
